<!-- EUSpace Hero Section -->
<section class="eu-hero" aria-label="Welcome to EUSpace">
  <div class="container">
    <div class="row align-items-center">

      <div class="col-lg-7">
        <p class="eu-hero__eyebrow">Elizade University Institutional Repository</p>
        <h1>Discover &amp; Share University Research</h1>
        <p class="lead">
          Open access to theses, dissertations, journal articles, conference
          papers and research outputs produced by Elizade University.
        </p>

        <!-- Delegate to DSpace's search form component, styled via SCSS -->
        <div class="eu-hero__search-wrapper">
          <ds-search-form
            [large]="true"
            [brandColor]="'primary'"
            [inPlaceSearch]="false"
            [searchPlaceholder]="'Search EUSpace…'">
          </ds-search-form>
        </div>

        <!-- Quick browse links -->
        <div class="eu-hero__links mt-3">
          <span class="eu-hero__links-label">Browse by:</span>
          <a [routerLink]="['/browse', 'title']">Title</a>
          <a [routerLink]="['/browse', 'author']">Author</a>
          <a [routerLink]="['/browse', 'dateissued']">Date</a>
          <a [routerLink]="['/browse', 'subject']">Subject</a>
          <a [routerLink]="['/community-list']">Faculties &amp; Depts</a>
        </div>

        <!-- Repository stats row -->
        <div class="eu-hero__stats" aria-label="Repository statistics">
          <div class="stat">
            <div class="stat__number">{{ itemCount$ | async }}</div>
            <div class="stat__label">Publications</div>
          </div>
          <div class="stat">
            <div class="stat__number">{{ communityCount$ | async }}</div>
            <div class="stat__label">Faculties</div>
          </div>
          <div class="stat">
            <div class="stat__number">{{ collectionCount$ | async }}</div>
            <div class="stat__label">Departments</div>
          </div>
        </div>
      </div>

      <!-- Right panel (desktop only) -->
      <div class="col-lg-4 offset-lg-1 d-none d-lg-block">
        <div class="eu-hero__panel">
          <h2 class="eu-hero__panel-title">Quick Access</h2>
          <ul class="eu-hero__panel-list">
            <li>
              <a [routerLink]="['/submit']">
                <i class="fas fa-upload" aria-hidden="true"></i>
                Submit Research
              </a>
            </li>
            <li>
              <a [routerLink]="['/mydspace']">
                <i class="fas fa-user-circle" aria-hidden="true"></i>
                My DSpace
              </a>
            </li>
            <li>
              <a [routerLink]="['/community-list']">
                <i class="fas fa-sitemap" aria-hidden="true"></i>
                Communities &amp; Collections
              </a>
            </li>
            <li>
              <a [routerLink]="['/statistics']">
                <i class="fas fa-chart-bar" aria-hidden="true"></i>
                Statistics
              </a>
            </li>
            <li>
              <a href="https://elizadeuniversity.edu.ng" target="_blank" rel="noopener noreferrer">
                <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                University Website
              </a>
            </li>
          </ul>
          <hr class="eu-hero__panel-divider">
          <a [routerLink]="['/register']" class="btn btn-block eu-btn-register">
            <i class="fas fa-user-plus mr-1" aria-hidden="true"></i>
            Register as Researcher
          </a>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- About EUSpace strip -->
<section class="eu-about-strip" aria-label="About EUSpace">
  <div class="container">
    <div class="eu-about-strip__inner">
      <div class="eu-about-strip__text">
        <h2>About EUSpace</h2>
        <p>EUSpace is the official digital repository of Elizade University, preserving and providing open access
           to the institution's scholarly and research output for the benefit of researchers, students, and the
           global academic community.</p>
        <a routerLink="/info/about" class="eu-btn-learn-more">Learn more about EUSpace</a>
      </div>
      <ul class="eu-about-strip__features">
        <li><span class="eu-check" aria-hidden="true">✓</span>OAI-PMH compliant for global discoverability</li>
        <li><span class="eu-check" aria-hidden="true">✓</span>Persistent handles and DOI assignment</li>
        <li><span class="eu-check" aria-hidden="true">✓</span>Google Scholar &amp; Crossref indexed</li>
        <li><span class="eu-check" aria-hidden="true">✓</span>ORCID integration for researcher profiles</li>
        <li><span class="eu-check" aria-hidden="true">✓</span>NDLTD member — theses &amp; dissertations</li>
        <li><span class="eu-check" aria-hidden="true">✓</span>Creative Commons licensing options</li>
      </ul>
    </div>
  </div>
</section>
